import { tireOrderingTestInstance } from '../axios';

const getProductCodes = (data: any) =>
  tireOrderingTestInstance.post('/product-code', data);

export default getProductCodes;